import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false

import App from './App.vue';
import VueRouter from 'vue-router'

// Componentes principales
import AdministrarUsers from './components/AdministrarUsers.vue'
import LoginPage from './components/LoginPage.vue'
import DashboardTest from './components/DashboardTest.vue'
import PageInicial from './components/PageInicial.vue'
import Nosotros from './components/Nosotros.vue'
import ContactCenter from './components/ContactCenter.vue'
import Cursos from './components/Cursos.vue'
import Servicios from './components/Servicios.vue'
import ConTacto from './components/Contacto.vue'
import PortafolioBusqueda from './components/PortafolioBusqueda.vue'
import Blog from './components/Blog.vue'
import BlogPost from './components/BlogPost.vue'

// Importar páginas de portafolio
import BeautySalon from './views/BeautySalon.vue'
import SpaZen from './views/SpaZen.vue'
import TallerExpress from './views/TallerExpress.vue'
import AutopartsStore from './views//AutopartsStore.vue'
import ColegioSanJuan from './views/ColegioSanJuan.vue'
import AcademiaOnline from './views/AcademiaOnline.vue'
import RestauranteSabores from './views/RestauranteSabores.vue'
import PizzeriaItalia from './views/PizzeriaItalia.vue'
import ClinicaSalud from './views/ClinicaSalud.vue'
import FarmaciaPlus from './views/FarmaciaPlus.vue'
import FashionStore from './views/FashionStore.vue'
import TechSolutions from './views/TechSolutions.vue'

Vue.use(Vuetify)
Vue.use(VueRouter)

const routes = [
  // Rutas principales
  {
    path: '/',
    name: 'ContactCenter',
    component: ContactCenter
  },
  {
    path: '/inicio',
    name: 'PageInicial',
    component: PageInicial,
  },
  {
    path: '/nosotros',
    name: 'Nosotros',
    component: Nosotros,
  },
  {
    path: '/servicios',
    name: 'Servicios',
    component: Servicios,
  },
  {
    path: '/portafolio',
    name: 'Portafolio',
    component: PortafolioBusqueda
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog,
  },
  {
    path: '/blog/:id',
    name: 'BlogPost',
    component: BlogPost,
    props: true
  },
  {
    path: '/contacto',
    name: 'Contacto',
    component: ConTacto,
  },
  {
    path: '/cursos',
    name: 'Cursos',
    component: Cursos,
  },
  
  // Rutas de portafolio - Belleza
  {
    path: '/portafolio/beauty-salon',
    name: 'BeautySalon',
    component: BeautySalon,
    meta: { title: 'Salón Bella Vida' ,fullPage: true }
  },
  {
    path: '/portafolio/spa-zen',
    name: 'SpaZen',
    component: SpaZen,
    meta: { title: 'Spa Zen' ,fullPage: true }
  },
  
  // Rutas de portafolio - Mecánica
  {
    path: '/portafolio/taller-express',
    name: 'TallerExpress',
    component: TallerExpress,
    meta: { title: 'Taller Express',fullPage: true  }
  },
  {
    path: '/portafolio/autoparts-store',
    name: 'AutopartsStore',
    component: AutopartsStore,
    meta: { title: 'Autoparts Store',fullPage: true  }
  },
  
  // Rutas de portafolio - Educación
  {
    path: '/portafolio/colegio-san-juan',
    name: 'ColegioSanJuan',
    component: ColegioSanJuan,
    meta: { title: 'Colegio San Juan',fullPage: true  }
  },
  {
    path: '/portafolio/academia-online',
    name: 'AcademiaOnline',
    component: AcademiaOnline,
    meta: { title: 'Academia Online' ,fullPage: true }
  },
  
  // Rutas de portafolio - Restaurantes
  {
    path: '/portafolio/restaurante-sabores',
    name: 'RestauranteSabores',
    component: RestauranteSabores,
    meta: { title: 'Restaurante Sabores' ,fullPage: true }
  },
  {
    path: '/portafolio/pizzeria-italia',
    name: 'PizzeriaItalia',
    component: PizzeriaItalia,
    meta: { title: 'Pizzería Italia',fullPage: true  }
  },
  
  // Rutas de portafolio - Salud
  {
    path: '/portafolio/clinica-salud',
    name: 'ClinicaSalud',
    component: ClinicaSalud,
    meta: { title: 'Clínica Salud' ,fullPage: true }
  },
  {
    path: '/portafolio/farmacia-plus',
    name: 'FarmaciaPlus',
    component: FarmaciaPlus,
    meta: { title: 'Farmacia Plus',fullPage: true  }
  },
  
  // Rutas de portafolio - E-commerce
  {
    path: '/portafolio/fashion-store',
    name: 'FashionStore',
    component: FashionStore,
    meta: { title: 'Fashion Store',fullPage: true  }
  },
  
  // Rutas de portafolio - Corporativo
  {
    path: '/portafolio/tech-solutions',
    name: 'TechSolutions',
    component: TechSolutions,
    meta: { title: 'Tech Solutions',fullPage: true  }
  },
  
  // Rutas de autenticación y administración
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/administrar',
    name: 'Administrar',
    component: AdministrarUsers,
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardTest,
    meta: { requiresAuth: true }
  },
  
  // Ruta para manejar 404 - Página no encontrada
  {
    path: '*',
    name: 'NotFound',
    component: () => import('./components/NotFound.vue'),
  }
]

// Configura el router con modo history
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// Guardia de navegación global
router.beforeEach((to, from, next) => {
  // Actualizar título de la página
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} | Consultora Innova`
  } else if (to.name) {
    document.title = `${to.name} | Consultora Innova`
  } else {
    document.title = 'Consultora Innova'
  }
  
  // Verificar autenticación para rutas protegidas
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = localStorage.getItem('userToken')
  
  if (requiresAuth && !isAuthenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

// Configuración de Vuetify con tema personalizado
const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#d7641a',
        secondary: '#2191c5',
        accent: '#ff9800',
        error: '#f44336',
        warning: '#ffc107',
        info: '#2196f3',
        success: '#4caf50'
      }
    },
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})

// Inicializar la aplicación
new Vue({
  vuetify,
  router,
  render: h => h(App),
}).$mount('#app')